import { specialList } from "@/mocks/news";

export default function Special() {
  const [main, ...others] = specialList;

  return (
    <section id="special" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between">
          <div>
            <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-focus-3-line" />
              Deep Dive
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              深度专题
            </h2>
          </div>
          <span className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-semibold text-secondary-900 sm:flex">
            <i className="ri-archive-line" />
            编辑部精选
          </span>
        </div>

        <div className="mt-8 grid gap-5 lg:grid-cols-3">
          {/* 主专题 */}
          <article className="group relative col-span-1 flex min-h-[420px] flex-col justify-end overflow-hidden rounded-2xl shadow-card lg:col-span-2 lg:row-span-2 lg:min-h-full">
            <img
              src={main.image}
              alt={main.title}
              className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
            <div className="relative p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-archive-fill" />
                {main.category}
              </span>
              <h3 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
                {main.title}
              </h3>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-50/90 md:text-base">
                {main.desc}
              </p>
              <div className="mt-5 flex items-center gap-4">
                <button
                  type="button"
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-lg bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
                >
                  阅读专题
                  <i className="ri-arrow-right-line" />
                </button>
                <span className="flex items-center gap-1.5 text-sm text-background-50/90">
                  <i className="ri-time-line" />
                  约需 {main.read}
                </span>
              </div>
            </div>
          </article>

          {/* 次专题 */}
          {others.map((item) => (
            <article
              key={item.id}
              className="group relative col-span-1 flex min-h-[220px] flex-col justify-end overflow-hidden rounded-2xl shadow-card"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
              <div className="relative p-5 md:p-6">
                <span className="inline-flex items-center rounded-full bg-background-50/90 px-2.5 py-0.5 text-xs font-semibold text-primary-700">
                  {item.category}
                </span>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-background-50">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-background-50/85">
                  {item.desc}
                </p>
                <span className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-accent-300">
                  约需 {item.read}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}